import React from 'react'
import { FilesModel } from './filesModel'
import FileCard from './FileCard'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles(
	(theme) => styles(theme)
)

interface AcceptingProps {
	files: FilesModel[]
}

type DownloadFilesProps = AcceptingProps

const DownloadFiles: React.FC<DownloadFilesProps> = (
	{
		files
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const filesContainerClass: ClassValue = classNames(
		classes.flexBetween,
		{
			[classes.flex]: isLargeScreen
		}
	)

	return (
		<div className={filesContainerClass}>
			{
				files.map(
					(file) => (
						file.url &&
						<FileCard
							key={file.name}
							file={file}
						/>
					)
				)
			}
		</div>
	)
}

export default DownloadFiles
